import { Route } from 'src/routes/Route'

export const ActConfigRoute = Route({
  path: '/config/:cardId',
  init: (cardId: string) => ({ cardId }),
  fromPath: ({ cardId }) => (cardId ? { cardId } : undefined),
})
export type ActConfigRoute = Route<typeof ActConfigRoute>
